export const G_listShorthands = new Map([
  ["t", "translate"],
  ["tx", "translateX"],
  ["ty", "translateY"],
  ["tz", "translateZ"],
  ["t3d", "translate3d"],

  ["s", "scale"],
  ["sx", "scaleX"],
  ["sy", "scaleY"],
  ["sz", "scaleZ"],
  ["s3d", "scale3d"],
  ["skew", "skew"],

  ["r", "rotate"],
  ["rz", "rotateZ"],
  ["rx", "rotateX"],
  ["ry", "rotateY"],
  ["r3d", "rotate3d"],

  ["sk", "skewX"],
  ["skx", "skewX"],
  ["sky", "skewY"],

  ["bg", "background-color"],
  ["bgi", "background-image"],
  ["bbm", "background-blend-mode"],
  ["o", "opacity"],
  ["c", "color"],
  ["cp", "clip-path"],

  ["bs", "box-shadow"],
  ["ts", "text-shadow"],
  ["br", "border-radius"],

  ["lg", "linear-gradient"],
  ["rg", "radial-gradient"],
  ["cg", "conic-gradient"],
  ["z", "z-index"],

  ["p", "padding"],
  ["pt", "padding-top"],
  ["pb", "padding-bottom"],
  ["pr", "padding-right"],
  ["pl", "padding-left"],

  ["m", "margin"],
  ["mt", "margin-top"],
  ["mb", "margin-bottom"],
  ["mr", "margin-right"],
  ["ml", "margin-left"],

  ["to", "transform-origin"],
  ["w", "width"],
  ["h", "height"],

  ["f", "filter"],
  ["bf", "backdrop-filter"],
]);
